import PropTypes from 'prop-types';
import { TableData } from '@utilities';

import styles from './_index.module.scss';

const ResultTable = ({ conditions, isLoading, tableData, type }) => {
  const modifiedTableData = tableData.map((obj) => {
    const modifiedObj = {};
    for (const [key, value] of Object.entries(obj)) {
      modifiedObj[key] = value.name;
    }
    return modifiedObj;
  });

  const renderColumns = () => {
    switch (type) {
      case 'product':
        return [
          {
            accessorKey: 'sector',
            format: 'text',
            header: 'Sector',
          },
          {
            accessorKey: 'dept',
            format: 'text',
            header: 'Department',
          },
          {
            accessorKey: 'majorcat',
            format: 'text',
            header: 'Major Category',
          },
          {
            accessorKey: 'category',
            format: 'text',
            header: 'Category',
          },
          {
            accessorKey: 'subcat',
            format: 'text',
            header: 'Subcategory',
          },
          {
            accessorKey: 'manufacturer',
            format: 'text',
            header: 'Manufacturer',
          },
          {
            accessorKey: 'parentbrand',
            format: 'text',
            header: 'Parent Brand',
          },
          {
            accessorKey: 'brand',
            format: 'text',
            header: 'Brand',
          },
        ];
      case 'store':
        return [
          {
            accessorKey: 'parentchannel',
            format: 'text',
            header: 'Parent Channel',
          },
          {
            accessorKey: 'channel',
            format: 'text',
            header: 'Channel',
          },
          {
            accessorKey: 'expanded_online_channel',
            format: 'text',
            header: 'Sub Channel',
          },
          {
            accessorKey: 'retailer',
            format: 'text',
            header: 'Retailer',
          },
          {
            accessorKey: 'banner',
            format: 'text',
            header: 'Banner',
          },
        ];
      default:
        return [];
    }
  };

  return (
    <div className={styles['result-table']}>
      <TableData
        columns={renderColumns()}
        data={modifiedTableData}
        isLoading={isLoading}
        renderEmptyMessage={() =>
          conditions?.breakoutConditions?.length > 0 ? (
            <>
              <h3>No results found.</h3>
              <p>Try refining your statements.</p>
            </>
          ) : (
            <>
              <h3>Results will appear here.</h3>
              <p>Add statements to see what is included.</p>
            </>
          )
        }
        stickyHeader
      />
    </div>
  );
};

ResultTable.propTypes = {
  conditions: PropTypes.object,
  isLoading: PropTypes.bool,
  tableData: PropTypes.array,
  type: PropTypes.string,
};

export default ResultTable;
